// @mui
import { styled } from "@mui/material/styles";
import {
  Box,
  Card,
  Stack,
  Container,
  Typography,
  Button,
  Divider,
} from "@mui/material";
// components
import Iconify from "../../components/Iconify";
import Page from "../../components/Page";
// sections
import { LoginForm } from "../../sections/auth/login";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  width: "100%",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.grey[100],
}));

const LoginCard = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 520,
  margin: "auto",
  borderRadius: theme.spacing(3),
  boxShadow: "0 24px 64px rgba(15, 23, 42, 0.12)",
  padding: theme.spacing(4),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(5),
  },
}));

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <Page title="Login">
      <RootStyle>
        <Container maxWidth="sm" sx={{ py: 6 }}>
          <LoginCard>
            <Stack spacing={4}>
              <Stack spacing={2.5} alignItems="center">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: 1,
                  }}
                >
                  <Box
                    component="img"
                    src="/static/logo/logo.png"
                    alt="ERapiNex"
                    sx={{
                      width: "100%",
                      maxWidth: 220,
                      height: "auto",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                <Stack spacing={1} alignItems="center" sx={{ textAlign: "center" }}>
                  <Typography variant="h3">Connexion</Typography>
                  <Typography sx={{ color: "text.secondary" }}>
                    Accédez à votre espace en entrant votre numéro et votre mot de passe.
                  </Typography>
                </Stack>
              </Stack>

              <Divider />

              <LoginForm />
            </Stack>
          </LoginCard>
        </Container>
      </RootStyle>
    </Page>
  );
}
